import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box, Collapse, IconButton, Stack, Typography } from "@mui/material";
import { ReactNode, useState } from "react";

/** Section chrome on the event card. A card with one section has nothing to
 * fold away, so `collapsible` is off and the chevron and Collapse are omitted. */
export function EventSection({
  title,
  caption,
  actions,
  collapsible = true,
  defaultExpanded = true,
  children,
}: {
  title: string;
  caption?: ReactNode;
  actions?: ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  children: ReactNode;
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        sx={{ mb: 2 }}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {collapsible && (
            <IconButton
              size="small"
              aria-label={expanded ? `Collapse ${title}` : `Expand ${title}`}
              aria-expanded={expanded}
              onClick={() => setExpanded((current) => !current)}
            >
              <ExpandMore
                fontSize="small"
                sx={{
                  transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
                  transition: "transform 150ms",
                }}
              />
            </IconButton>
          )}
          <Box>
            <Typography variant="subtitle2">{title}</Typography>
            {caption && (
              <Typography variant="body2" color="text.secondary" component="div">
                {caption}
              </Typography>
            )}
          </Box>
        </Stack>
        {actions}
      </Stack>
      {collapsible ? <Collapse in={expanded}>{children}</Collapse> : children}
    </Box>
  );
}
